// extracted by mini-css-extract-plugin
module.exports = {"copyButtonContainer":"copyButton_copyButtonContainer__1F1hb","input":"copyButton_input__2D3dj"};